class CustomPagination extends HTMLElement {
	constructor() {
		super();
		this.loadMoreBtn = this.querySelector("[js-load-more-btn]");
		this.items = this.querySelectorAll("[js-hb-item]");

		this.totalItem = this.items.length;
		this.limit = 8;
		this.page = 1;
		this.offset = this.page * this.limit;
		this.init();
	}

	init() {
		this.toggleLoadMoreBtn();
		this.loadMoreBtn.addEventListener("click", () => {
			this.page += 1;
			this.offset = this.page * this.limit;
			this.items.forEach((item, index) => {
				if (this.offset >= index + 1) {
					item.style.display = "block";
				}
				this.toggleLoadMoreBtn();
			});
		});
	}
	toggleLoadMoreBtn() {
		if (this.offset >= this.totalItem) {
			this.loadMoreBtn.style.display = "none";
		} else {
			this.loadMoreBtn.style.display = "inline-block";
		}
	}
}

customElements.define("custom-pagination", CustomPagination);
